module.exports = __webpack_public_path__ + "static/media/less30-icon.49e3065a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/less30-icon.svg
// module id = 2872
// module chunks = 0